import { API_URL, getCachedSessionId } from 'src/services/common';
import { FetchCustomersPaginatedResponseData } from './interfaces/fetchCustomersPaginated.interface';

import { api } from '../../../../util/axios-instance';

export const fetchCustomersPaginated = async (params: {
  current: string;
  limit: string;
  projectId: string;
  status: string;
}): Promise<FetchCustomersPaginatedResponseData | undefined> => {
  const response = await api.get<FetchCustomersPaginatedResponseData>(
    `${API_URL}/v1/project/${params.projectId}/provider/authentication/customersPaginated?page=${
      params.current
    }&limit=${params.limit}${params.status ? `&status=${params.status}` : ''}`,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );
  return response.data;
};
